var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { t } from "../../I18N";
import { Icon } from "../../UI";

const SnippetsTab = ({ snippets }) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "search" }), /*#__PURE__*/
_jsx("span", { className: "connectionsNumber" }, void 0, snippets.get('count') ? snippets.get('count') : ''), /*#__PURE__*/
_jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Search text'))
);






function mapStateToProps(state, props) {
  return {
    snippets: state[props.storeKey].sidepanel.snippets
  };
}

export default connect(mapStateToProps)(SnippetsTab);